import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeUntil, throttle } from 'rxjs/operators';

@Directive({
    selector: '[throttle-click]'
})
export class ThrottleClickDirective implements OnInit, OnDestroy {
    @Input('throttle-duration')
    public throttleDuration: number;
    @Output('throttle-click')
    public onClickEmitter: EventEmitter<PointerEvent>;

    private receivedClick: Subject<PointerEvent>;
    private directiveDestroyed: Subject<void>;

    constructor() {
        this.throttleDuration = 500;
        this.onClickEmitter = new EventEmitter<PointerEvent>();
        this.receivedClick = new Subject<PointerEvent>();
        this.directiveDestroyed = new Subject<void>();
    }

    public ngOnInit(): void {
        this.receivedClick.pipe(
            takeUntil(this.directiveDestroyed),
            throttle(() => timer(this.throttleDuration))
        ).subscribe(e => this.onClickEmitter.emit(e));
    }

    public ngOnDestroy(): void {
        this.directiveDestroyed.next();
        this.directiveDestroyed.complete();
    }

    @HostListener('click', ['$event'])
    public clickEvent($event: PointerEvent): void {
        this.receivedClick.next($event);
    }
}
